"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteRecipeMutationOptions = exports.deleteRecipeMutation = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../../user/fragments/meUser");
exports.deleteRecipeMutation = client_1.gql `
  mutation DeleteRecipe($id: String!) {
    deleteRecipe(id: $id) {
      __typename
      ok
      user {
        ...meUser
      }
    }
  }
  ${meUser_1.meUserFragment}
`;
exports.deleteRecipeMutationOptions = (variables) => ({
    variables,
    update: cache => {
        cache.evict({ id: "Recipe:" + variables.id });
        cache.gc();
    },
});
//# sourceMappingURL=deleteRecipe.js.map